import { CartAddEvent } from '@theme/events';
document.addEventListener('click',event=>{const open=event.target.closest('[data-quick-open]'),close=event.target.closest('[data-quick-close]');if(open){const dialog=open.closest('.blinc-quick').querySelector('dialog');dialog.showModal();}if(close)close.closest('dialog').close();if(event.target instanceof HTMLDialogElement){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right)event.target.close();}});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('blinc-quick__form')) return;
  event.preventDefault();
  const button = event.submitter, status = form.querySelector('[role="status"]');
  if (!(button instanceof HTMLButtonElement) || button.disabled || form.dataset.busy || !form.reportValidity()) return;
  const availableButtons = [...form.querySelectorAll('button[type="submit"]:not(:disabled)')];
  form.dataset.busy = 'true';
  availableButtons.forEach(item => item.disabled = true);
  button.disabled = true; status.textContent = '';
  try {
    const body = new FormData(form);
    body.set('id', button.value);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
    if (sections.length) body.set('sections',sections.join(','));
    const response = await fetch(Theme.routes.cart_add_url,{method:'POST',body,headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
    form.closest('dialog')?.close();
    const cart = undefined;
    form.dispatchEvent(new CartAddEvent(cart,form.id,{source:'blinc-quick-add',itemCount:1,variantId:body.get('id'),sections:result.sections}));
    status.textContent = Theme.translations.added;
  } catch (error) { status.textContent = error.message || status.dataset.error; }
  finally { delete form.dataset.busy; availableButtons.forEach(item => item.disabled = false); }
});
